import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../../modal/modal.component';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { NotesService } from '../../../shared/services/notes.service';
import { SubmissionRecordObject } from '../../../shared/services/submission-history-object';
import { SubmissionSearchObject, SubmissionSearchUserInfoObject} from '../search-object';
import { PaginationObject} from '../pagination-object';
import { ErrorDetails} from '../errors/errordetails';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from '../../../shared/services/modal.service';

@Component({
    selector: 'submission-history-table',
    templateUrl: './submission-history-table.component.html',
    styleUrls: [ './submission-history-table.component.scss' ]
})
export class SubmissionHistoryTableComponent implements OnInit, OnDestroy {

    @ViewChild('submissionSource')
    private modalSubmissionSource: ModalComponent;
    @ViewChild('errorDialog')
    private modalSubmissionErrors: ModalComponent;
    sourceModalTitle: string;
    sourceModalContent: string;
    sourceModalUuid: string;
    errorModalTitle: string;
    errorDetails: ErrorDetails[] = new Array<ErrorDetails>();

    activeFileRecordList: SubmissionRecordObject[] = new Array<SubmissionRecordObject>();

    activeFileRecord: SubmissionRecordObject;

    searchCriteria: SubmissionSearchObject =  new SubmissionSearchObject();

    pagination: PaginationObject = new PaginationObject();

    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();

    badgeCount: any;
    totalCount: any;
    btnTrigger: any;
    activeNote: any;

    private submissionTableSubscription: Subscription;
    private  searchCriteriaSubscription: Subscription;
    private      totalCountSubscription: Subscription;
    private      paginationSubscription: Subscription;
    private           notesSubscription: Subscription;
    private    errorDetailsSubscription: Subscription;
    private        userInfoSubscription: Subscription;
    private      clickEventsubscription: Subscription;

    constructor(private notesService: NotesService,
                readonly modalService: ModalService,
                private submissionHistoryService: SubmissionHistoryService,
                private matIconRegistry: MatIconRegistry,
                private domSanitizer: DomSanitizer) {
      this.badgeCount = ' '; // Space needed for visible note indicator
      this.matIconRegistry.addSvgIcon(
        `fhir`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`images/fhir_trademark_transparent.svg`)
      );
      this.matIconRegistry.addSvgIcon(
          'fhir_outline',
          this.domSanitizer.bypassSecurityTrustResourceUrl(`images/FHIR-logo.svg`)
      );
      this.clickEventsubscription = this.notesService.getCloseNoteEvent().subscribe(() => {
        this.closeNote();
      })
    }

    incrementCount() {
        this.badgeCount++;
    }

    clearCount() {
        this.badgeCount = 0;
    }

    public updateTableData(): void {
        this.submissionHistoryService.getSessionTableContent();
    }

    copyMessage(e: MouseEvent, val: string) {
        if (this.btnTrigger) {
            (this.btnTrigger as HTMLElement).classList.remove('down');
        }
        this.btnTrigger = e.target;
        if (this.btnTrigger instanceof HTMLElement) {
            (this.btnTrigger as HTMLElement).classList.add('down');
        }
        navigator.clipboard.writeText(val);
    }

    openNote(record: SubmissionRecordObject) {
        this.clearActiveNote();
        this.activeFileRecord = record;
        this.activeNote = document.getElementById('badge' + record.uuid)
        if (this.activeNote != null) {
            this.activeNote.removeAttribute('hidden');
            this.activeNote.style.backgroundColor = '#db6d00';
        }
        this.notesService.openNote(record.uuid);
    }


    clearActiveNote() {
        if (this.activeNote != null && this.activeFileRecord != null) {
            if (!this.activeFileRecord.notes) {
                this.activeNote.hidden = 'true';
            }
            this.activeNote.style.backgroundColor = '#DA33FF';
            this.activeNote = null;
        }
    }


    closeNote() {
        this.clearActiveNote();
    }


    private toggleNoteBadge(uuid: string, noteExists: boolean) {
        for (const record of this.activeFileRecordList) {
            if (record.uuid === uuid) {
                record.notes = noteExists;
            }
        }
    }

    resolve(checked: boolean, uuid: any) {
        this.submissionHistoryService.resolve(checked, uuid).then(result =>  {
        if (result) {
        }});
    }

    review(checked: boolean, uuid: any) {
      this.submissionHistoryService.review(checked, uuid).then(result =>  {
        if (result) {

        }});
    }

    extract() {
        if (this.searchCriteria != null
            && this.searchCriteria.submissionIdentifierType !== ''
            && this.searchCriteria.submissionIdentifierType != null) {
            this.extractSearch();
        } else {
            this.submissionHistoryService.getSessionTableExportContent();
        }
    }

    extractSearch() {
        const startDateElement = document.querySelector('#startDate') as HTMLInputElement;
        const startTimeElement = document.querySelector('#startTime') as HTMLInputElement;
        const endDateElement = document.querySelector('#endDate') as HTMLInputElement;
        const endTimeElement = document.querySelector('#endTime') as HTMLInputElement;

        const startDateTime = (startDateElement && startDateElement.value) ?
            startDateElement.value + ' ' + (startTimeElement ? startTimeElement.value : '') : '';
        const endDateTime = (endDateElement && endDateElement.value) ?
            endDateElement.value + ' ' + (endTimeElement ? endTimeElement.value : '') : '';

        this.submissionHistoryService.getSearchTableExportContent(this.searchCriteria, startDateTime.trim(), endDateTime.trim(), 0);
    }

    getTotalCount() {
        this.submissionHistoryService.getTotalCount()
    }

    reprocessSubmission(uuid: any) {
        this.submissionHistoryService.reprocessSubmission(uuid);
    }

    ngOnInit() {
        this.submissionTableSubscription = this.submissionHistoryService.currentSubmissionTable
                                                .subscribe(message => this.activeFileRecordList = message);
        this.searchCriteriaSubscription = this.submissionHistoryService.currentSearchCriteria
                                                .subscribe(message => this.searchCriteria = message);
        this.totalCountSubscription = this.submissionHistoryService.currentTotalCount.subscribe(message => this.totalCount = message);
        this.paginationSubscription = this.submissionHistoryService.currentPagination.subscribe(message => this.pagination = message);
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => this.userInfo = message);
        if (!this.activeFileRecordList) {
            this.updateTableData();
            this.getTotalCount();
        }
        // Subscribe to submission errors
        this.errorDetailsSubscription = this.submissionHistoryService.currentErrorDetails.subscribe(errors => {
            this.errorDetails = errors;
            if (errors !== null) {
                this.errorModalTitle = 'Error Message (' + errors.length + ' error' + ((errors.length === 1) ? '' : 's') + ' found)';
            } else {
                this.errorModalTitle = '';
            }
        });

        // This function gets called when the notes component want a purple badge icon toggled on/off
        this.notesSubscription = this.notesService.noteExists$.subscribe(status => this.toggleNoteBadge(status.uuid, status.noteExists));
    }

    ngOnDestroy() {
        this.submissionTableSubscription.unsubscribe();
        this.searchCriteriaSubscription.unsubscribe();
        this.totalCountSubscription.unsubscribe();
        this.paginationSubscription.unsubscribe();
        this.errorDetailsSubscription.unsubscribe();
        this.notesSubscription.unsubscribe();
        this.userInfoSubscription.unsubscribe();
    }

    public displaySourceDialog(uuid: string, hmlId: string, uploaderFileName: string, submissionStatus: string, testType?: string): void {
        this.modalService.openSubmissionSourceDialog(uuid, hmlId, uploaderFileName, submissionStatus, testType);
    }

    public displayErrorDialog(uuid: string): void {
        this.errorModalTitle = 'Loading submission errors...';
        this.errorDetails = [];

        this.submissionHistoryService.getErrors(uuid); // Subscribed to Observable ErrorDetails in service
        this.modalSubmissionErrors.open();
    }


}
